import React from 'react';
import set from 'lodash/set';
import { GroupIndent } from '../../';
import { Controller, } from '../../../../core';
import { useOneOf } from '../../../hooks';
import { block } from '../../../utils';
import './OneOf.css';
const b = block('oneof');
const OneOfComponent = (props) => {
    var _a;
    const { oneOfValue, specProperties, toggler } = useOneOf({ props });
    const parentOnChange = React.useCallback((childName, childValue, childErrors) => {
        const value = set({}, childName.split(`${props.input.name}.`).join(''), childValue);
        props.input.onChange(value, childErrors);
    }, [props.input.onChange, props.input.name]);
    return (React.createElement("div", { className: b({
            base: !props.withoutIndent,
            flat: props.withoutIndent,
        }) },
        toggler,
        specProperties[oneOfValue] ? (React.createElement(GroupIndent, null,
            React.createElement(Controller, { value: (_a = props.input.value) === null || _a === void 0 ? void 0 : _a[oneOfValue], spec: specProperties[oneOfValue], name: `${props.name}.${oneOfValue}`, parentOnChange: parentOnChange, parentOnUnmount: props.input.parentOnUnmount, key: `${props.name}.${oneOfValue}` }))) : null));
};
export const OneOf = OneOfComponent;
export const OneOfFlat = (props) => (React.createElement(OneOfComponent, Object.assign({}, props, { withoutIndent: true })));
